import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=2b8a40be&scoped=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&id=2b8a40be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a40be",
  null
  
)

export default component.exports